import { parseISO, format } from 'date-fns'

const parseDate = (dateString, where) => {

    let parsedISO = Date.parse(dateString);

    return parsedISO ? format(parsedISO, "dd MMM yyyy") : "No Date"
  
  }

export default parseDate;